module.exports = __webpack_public_path__ + "img/hr-steel-furnace-fire.f7dc6253.png";